module.exports = __webpack_public_path__ + "img/34.9b963cdb.png";